/// <amd-module name="Build/Flux/Common" />
export interface IDisposable {
    dispose(): void;
}
